import React from 'react'
import { Button } from '@themesberg/react-bootstrap'
import moment from 'moment-timezone'

export const TableRow = (props) => {
  const { name, resultDate, resultTime, onEdit } = props;

  // Kiểm tra xem kỳ này có phải là kỳ tương lai không
  const isFuturePeriod = moment(resultTime).isAfter(moment());

  return (
    <tr>
      <td className="text-center">{'#' + name || ""}</td>
      <td className="text-center">{resultDate}</td>
      <td className="text-center">
        {isFuturePeriod && (
          <Button 
            variant="warning" 
            size="sm" 
            onClick={() => onEdit && onEdit(props)}
          >
            Sửa
          </Button>
        )}
      </td>
    </tr>
  );
};